<!--
 * @Description: 根据tab限制内容
 * @Date: 2021-02-03 17:14:07
-->
<template>
  <div class="living-content">
    <!-- 评论,使用show防止组件内重新计时 -->
    <comment
      v-show="livingStore.currentZdyMenu.type === 100"
      :qa-id="livingStore.detail.id"
      :type="3"
      :name="livingStore.detail.title"
      :detail="livingStore.detail"
      :isLive="true"
    ></comment>
    <!-- 直播限制问卷 -->
    <survey
      v-if="livingStore.currentZdyMenu.type === 2"
      :questionnaireId="livingStore.currentZdyMenu.questionnaireId"
      :key="livingStore.currentZdyMenu.questionnaireId"
    ></survey>
    <!-- 直播配置内容 -->
    <div
      class="pre"
      style="padding: 0.32rem"
      v-if="livingStore.currentZdyMenu.type === 1"
      v-html="livingStore.currentZdyMenu.content || '无'"
    ></div>
  </div>
</template>

<script>
import comment from '@/components/comment';
import survey from '@/views/survey';

export default {
  name: 'LivingContent',
  inject: ['livingStore'],
  components: {
    comment,
    survey
  }
};
</script>

<style lang="scss">
.living-content {
  .pre {
    & > p {
      max-width: 100%;
      word-break: break-all;
    }
  }
}
</style>
